export function SET_MACHINERY_CHECK_QUESTIONS(state, check_questions) {
    state.check_questions = check_questions;
}

export function SET_MACHINERY_CHECK_QUESTION(state, check_question) {
    state.check_question = check_question;
}

